export const baseApiUrl = 'https://namezs-server.onrender.com/'